import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { StudentInnovationsRoutingModule } from './student-innovations-routing.module';
import { StudentInnovationsListComponent } from './student-innovations-list/student-innovations-list.component';
import { StudentInnovationsCreateComponent } from './student-innovations-create/student-innovations-create.component';

@NgModule({
  declarations: [StudentInnovationsListComponent, StudentInnovationsCreateComponent],
  imports: [
    CommonModule,
    StudentInnovationsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class StudentInnovationsModule { }
